import { Permissions } from 'types/permissions';

export const getCustomSettingsTitle = (permissions: Permissions) =>
  permissions.has('can_view_orders') ? 'Order settings' : 'Bridge settings';
